import { HouseholdLayout } from '@/components/layouts/HouseholdLayout.jsx';
import { RecipeForm } from '../components/RecipeForm';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useCreateRecipeMutation } from '../api';
import { useCreateMealPlanEntryMutation } from '@/features/meals/meal-plan/api';
import { newRecipe } from '../schema';

export function CreateRecipePage() {
  const { householdId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Set when this page was reached from the add meal plan screen -- once
  // the recipe is saved, it also gets slotted into that exact meal instead of
  // just landing on its own page.
  const planDate = searchParams.get('planDate');
  const planMealType = searchParams.get('planMealType');
  const isAddingToMealPlan = !!(planDate && planMealType);

  const data = newRecipe();
  const [saveRecipe, saveResult] = useCreateRecipeMutation();
  const [createMealPlanEntry] = useCreateMealPlanEntryMutation();

  function save(data) {
    return saveRecipe({ householdId, data });
  }

  async function handleSaved(recipe) {
    if (!isAddingToMealPlan) {
      navigate(`/h/${householdId}/recipes/${recipe.id}`);
      return;
    }

    const result = await createMealPlanEntry({
      householdId,
      data: {
        date: planDate,
        entry_type: 'recipe',
        recipe_id: recipe.id,
        meal_type: planMealType,
      },
    });

    if (result.error) {
      // The recipe itself saved fine -- don't strand the user on a broken
      // page over a secondary failure, just send them to what they made.
      console.error('Recipe created, but failed to add it to the meal plan:', result.error);
      navigate(`/h/${householdId}/recipes/${recipe.id}`);
      return;
    }

    navigate(`/h/${householdId}/meals/plan?date=${planDate}`);
  }

  return (
    <HouseholdLayout>
      <RecipeForm title="Create New Recipe" data={data} save={save} saveResult={saveResult} onSaved={handleSaved} />
    </HouseholdLayout>
  );
}
